import Mutations from '../../odata/mutations';

export default { ...new Mutations('completedChecklist'), ...new Mutations('completedChecklists') };
